import React, { useContext, useEffect, useRef, useState } from 'react';
import './TextPlayer.module.scss';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStop, faVolume } from '@fortawesome/pro-solid-svg-icons';
import { useAudio } from 'utilities/useAudio';
import { GlobalContext } from 'utilities/GlobalContext';
import { CalendarContext } from '../../Calendar';

type Props = {
    text: string;
    subTitle?: string | null;
    shouldAuthenticate?: boolean;
    id: number;
};

export default function TextPlayer({
    text,
    subTitle,
    id,
    shouldAuthenticate = true,
}: Props) {
    const [value, setValue] = useState<string>(text || '');
    const [readSpeakerValue, setReadSpeakerValue] = useState<
        string | undefined
    >(undefined);

    const { play, isPlaying, stop, url } = useAudio({
        text: readSpeakerValue,
    });

    const isReallyPlaying = !url?.[0] ? false : isPlaying;

    useEffect(() => {
        if (url) play();
    }, [url]);

    const { setActiveLog } = useContext(CalendarContext);
    const { logbookAuthenticated } = useContext(GlobalContext);

    const textareaRef = useRef<HTMLTextAreaElement>(null!);

    function handleClick() {
        if (value !== readSpeakerValue) setReadSpeakerValue(value);

        if (isReallyPlaying) {
            stop();
        } else if (value === readSpeakerValue) play();
    }

    function handleChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
        setValue(e.target.value);

        setActiveLog((prev) => ({
            ...prev,
            attributes: {
                ...prev.attributes,
                fields: [
                    ...prev.attributes.fields.map((v) =>
                        v?.id === id ? { ...v, text: e.target.value } : v
                    ),
                ],
            },
        }));
    }

    useEffect(() => {
        if (text !== value) setValue(text);
    }, [text]);

    const cantType = shouldAuthenticate && !logbookAuthenticated;

    useEffect(() => {
        textareaRef.current.style.height = '0px';
        const { scrollHeight } = textareaRef.current;
        textareaRef.current.style.height = `${scrollHeight}px`;
    }, [value]);

    return (
        <div styleName="example">
            <CircleButton
                onClick={handleClick}
                color={!isReallyPlaying ? 'grey' : 'blue'}
            >
                <FontAwesomeIcon icon={isReallyPlaying ? faStop : faVolume} />
            </CircleButton>
            <div styleName="text-wrapper">
                <p>{subTitle}</p>
                <textarea
                    value={value}
                    onChange={handleChange}
                    styleName="text"
                    ref={textareaRef}
                    style={{ cursor: cantType ? 'default' : 'initial' }}
                    readOnly={cantType}
                />
            </div>
        </div>
    );
}
